import ButtonT from '@components/tailwind-components/Button/ButtonT';
import LabelT from '@components/tailwind-components/Label/LabelT';
import { useModal } from '@hooks/modal/useModal';
import { useCompanySettingsActions } from '@hooks/settings/company/useCompanyActions';
import type React from 'react';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import BulkInviteMembersList from './BulkInviteMembersList';
import type { TFormattedEmail } from './bulkinvite.type';

export type TBulkInviteReviewModalProps = {
  members: TFormattedEmail[];
};

export const BulkInviteReviewModal: React.FC<TBulkInviteReviewModalProps> = ({
  members,
}) => {
  const { t } = useTranslation();
  const { hideModal, showModal } = useModal();
  const { bulkInviteMembers } = useCompanySettingsActions();

  const onSubmit = useCallback(() => {
    // * Get only the valid emails
    const data = members.filter((data) => !data.error);
    return bulkInviteMembers(data);
  }, [members, bulkInviteMembers]);

  const inviteCount = useMemo(() => {
    return members.filter((member) => !member.error).length;
  }, [members]);

  const hideAndSubmit = useCallback(() => {
    onSubmit();
    hideModal();
  }, [onSubmit, hideModal]);

  const handlePreviousButton = useCallback(() => {
    return showModal('bulk-invite-members', '', { emails: members });
  }, [members, showModal]);

  return (
    <form className='tailwind-modal-form' onSubmit={() => hideAndSubmit()}>
      <div className='tailwind-modal-body'>
        <LabelT text={t('members-settings.bulk-invite.review-description')} />
        <LabelT
          className='mt-2'
          text={t('members-settings.bulk-invite.review-invite-count', {
            inviteCount,
          })}
        />

        <BulkInviteMembersList id={'member-list'} members={members} />
      </div>
      <div className='tailwind-modal-footer mt-8'>
        <ButtonT
          type='button'
          styling='cancel'
          size='xs'
          rounding='md'
          onClick={hideModal}>
          {t('general.buttons.cancel')}
        </ButtonT>
        <ButtonT
          type='button'
          styling='primary'
          size='xs'
          rounding='md'
          onClick={handlePreviousButton}>
          {t('general.buttons.previous')}
        </ButtonT>
        <ButtonT type='submit' styling='primary' size='xs' rounding='md'>
          {t('general.buttons.save')}
        </ButtonT>
      </div>
    </form>
  );
};

export default BulkInviteReviewModal;
